import AxiosInstance from "./Axios";

export async function getDashboardData() {
  try {
    const response = await AxiosInstance.get("/dashboard");
    return response.data;
  } catch (error) {
    console.error("Dashboard API error:", error);
    throw error;
  }
}
